const unicodeRegex = /\\u\{?([a-fA-F0-9]{4,6})\}?/g;
export const replaceUnicodeWithEmoji = (text) => {
    return text.replace(unicodeRegex, (match, code) => {
    try {
        return String.fromCodePoint(parseInt(code, 16));
    } catch (e) {
        return match; // Return the original match if parsing fails
    }
    });
}